import classNames from 'classnames';
import type { LocationDescriptor } from 'history';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { CardItem } from 'src/app/components/Elements/Card';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import styles from './styles.module.scss';

const clickNoop = e => e.preventDefault();

interface LinkToCardItemProps {
  to?: LocationDescriptor<unknown>;
  isDisabled?: boolean;
  children: any;
  className?: string;
  onClick: any;
  showArrow?: boolean;
  disabled?: boolean;
  noMaxWidth?: boolean;
  [key: `data-${string}`]: any;
}

const LinkToCardItem = ({
  to,
  isDisabled,
  children,
  className,
  onClick,
  showArrow = true,
  noMaxWidth = false,
  ...rest
}: LinkToCardItemProps) => {
  isDisabled = isDisabled || !to;
  return (
    <CardItem
      tag={to ? Link : 'div'}
      to={to}
      onClick={isDisabled ? clickNoop : onClick}
      className={classNames(styles.component, className, styles._specific, {
        [styles.disabled]: isDisabled,
      })}
      {...rest}
    >
      <div
        className={classNames(styles.contentContainer, {
          [styles.noMaxWidth]: noMaxWidth,
        })}
      >
        {children}
      </div>
      {showArrow && (
        <div className={styles.arrow}>
          <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.system_nav_forward_arrow} block />
        </div>
      )}
    </CardItem>
  );
};

LinkToCardItem.propTypes = {
  to: PropTypes.string,
  isDisabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default LinkToCardItem;
